import type { JSX } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useCustomTranslation } from "@plansoft-configuration-renderer/localization";

import { ButtonUiProps } from "./ButtonUiProps";
import { useButtonUiImageIcons } from "./useButtonUiImageIcons";

export function ButtonUi(props: ButtonUiProps): JSX.Element {
  const {
    buttonFullWidth,
    buttonColor,
    buttonText,
    buttonVariant,
    wrapperSxProps,
    onClick,
  } = props;

  const { t } = useCustomTranslation();
  const { startIcon, endIcon } = useButtonUiImageIcons(props);

  return (
    <Box sx={wrapperSxProps}>
      <Button
        startIcon={startIcon}
        endIcon={endIcon}
        color={buttonColor}
        variant={buttonVariant}
        onClick={onClick}
        fullWidth={buttonFullWidth}
        disabled={props.disabled}
      >
        {t(buttonText)}
      </Button>
    </Box>
  );
}
